import type ColorPerFeatureStyleSettingsModule from "./colorPerFeatureStyleSettingsModule";
import type ConditionalStyleSettingsModule from "./conditionalStyleSettingsModule";
import type ThematicSettingsModule from "./thematicSettingsModule";

export default class PointStyleSettingsModule {
    private thematicSettings: ThematicSettingsModule;
    private conditionalStyleSettings: ConditionalStyleSettingsModule;
    private colorPerFeatureStyleSettings: ColorPerFeatureStyleSettingsModule;

    constructor(thematicSettings: ThematicSettingsModule, conditionalStyleSettings: ConditionalStyleSettingsModule, colorPerFeatureStyleSettings: ColorPerFeatureStyleSettingsModule) {
        this.thematicSettings = thematicSettings;
        this.conditionalStyleSettings = conditionalStyleSettings;
        this.colorPerFeatureStyleSettings = colorPerFeatureStyleSettings;
    }

    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        // TODO FIXME will not return attributes required for labeling...
        
        const requiredAttributes: string[] = [];
        if (styleSettings.conditionalStyleSettings) {
            let attrs = this.conditionalStyleSettings.getRequiredAttributes(styleSettings.conditionalStyleSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }
        
        if (styleSettings.colorThematicSettings) {
            let attrs = this.thematicSettings.getRequiredAttributes(styleSettings.colorThematicSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }
        
        if (styleSettings.sizeThematicSettings) {
            let attrs = this.thematicSettings.getRequiredAttributes(styleSettings.sizeThematicSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }
        
        if (styleSettings.symbolThematicSettings) {
            let attrs = this.thematicSettings.getRequiredAttributes(styleSettings.symbolThematicSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }
        
        if (styleSettings.colorPerFeatureSettings) {
            let attrs = this.colorPerFeatureStyleSettings.getRequiredAttributes(styleSettings.colorPerFeatureSettings, territoryModel);
            requiredAttributes.push.apply(requiredAttributes, attrs);
        }

        if (styleSettings.heatMapSettings && styleSettings.heatMapSettings.attr !== undefined) {
            requiredAttributes.push(styleSettings.heatMapSettings.attr);
        }
        
        return _.uniq(requiredAttributes);
    }
}
